<template>
  <div>
    <h4>Social Medias</h4>
    <p>Please enter relevant social media accounts.</p>
    <hr />
    <div class="row">
      <div class="form-group col-md-11 input-group" style="margin: 20px;">
        <span
          class="input-group-addon"
          style="background: white; width: 110px;"
        >
          <span>Facebook</span>
        </span>
        <input class="form-control" v-model="facebook" type="url" />
      </div>

      <div class="form-group col-md-11 input-group" style="margin: 20px;">
        <span
          class="input-group-addon"
          style="background: white; width: 110px;"
        >
          <span>Twitter</span>
        </span>
        <input class="form-control" v-model="twitter" type="url" />
      </div>

      <div class="form-group col-md-11 input-group" style="margin: 20px;">
        <span
          class="input-group-addon"
          style="background: white; width: 110px;"
        >
          <span>LinkedIn</span>
        </span>
        <input class="form-control" v-model="linkedIn" type="url" />
      </div>
      <div class="form-group col-md-11 input-group" style="margin: 20px;">
        <span
          class="input-group-addon"
          style="background: white; width: 110px;"
        >
          <span>Instagram</span>
        </span>
        <input class="form-control" v-model="instagram" type="url" />
      </div>

      <div class="form-group col-md-11 input-group" style="margin: 20px;">
        <span
          class="input-group-addon"
          style="background: white; width: 110px;"
        >
          <span>Google+</span>
        </span>
        <input class="form-control" v-model="googlePlus" type="url" />
      </div>
      <div class="form-group col-md-11 input-group" style="margin: 20px;">
        <span
          class="input-group-addon"
          style="background: white; width: 110px;"
        >
          <span>WeChat</span>
        </span>
        <input class="form-control" v-model="weChat" type="url" />
      </div>
      <div class="form-group col-md-11 input-group" style="margin: 20px;">
        <span
          class="input-group-addon"
          style="background: white; width: 110px;"
        >
          <span>AngelList</span>
        </span>
        <input class="form-control" v-model="angelList" type="url" />
      </div>

      <div class="form-group col-md-11 input-group" style="margin: 20px;">
        <span
          class="input-group-addon"
          style="background: white; width: 110px;"
        >
          <span>CrunchBase</span>
        </span>
        <input class="form-control" v-model="crunchBase" type="url" />
      </div>
      <div class="form-group col-md-11 input-group" style="margin: 20px;">
        <span
          class="input-group-addon"
          style="background: white; width: 110px;"
        >
          <span>YouTube</span>
        </span>
        <input class="form-control" v-model="youTube" type="url" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import textInput from "./textInput.vue";

export default {
  name: "provider-page",
  components: {
    textInput: textInput
  },
  computed: {
    ...mapGetters({
      getProperty: "getEditedProviderValueByKeyChain"
    }),
    facebook: {
      set: function(editedData) {
        this.setSocialMediaValue(1)(editedData);
      },
      get: function() {
        return this.getSocialMediaValue(1);
      }
    },
    twitter: {
      set: function(editedData) {
        this.setSocialMediaValue(2)(editedData);
      },
      get: function() {
        return this.getSocialMediaValue(2);
      }
    },
    linkedIn: {
      set: function(editedData) {
        this.setSocialMediaValue(3)(editedData);
      },
      get: function() {
        return this.getSocialMediaValue(3);
      }
    },
    instagram: {
      set: function(editedData) {
        this.setSocialMediaValue(4)(editedData);
      },
      get: function() {
        return this.getSocialMediaValue(4);
      }
    },
    googlePlus: {
      set: function(editedData) {
        this.setSocialMediaValue(5)(editedData);
      },
      get: function() {
        return this.getSocialMediaValue(5);
      }
    },
    weChat: {
      set: function(editedData) {
        this.setSocialMediaValue(6)(editedData);
      },
      get: function() {
        return this.getSocialMediaValue(6);
      }
    },
    angelList: {
      set: function(editedData) {
        this.setSocialMediaValue(7)(editedData);
      },
      get: function() {
        return this.getSocialMediaValue(7);
      }
    },
    crunchBase: {
      set: function(editedData) {
        this.setSocialMediaValue(8)(editedData);
      },
      get: function() {
        return this.getSocialMediaValue(8);
      }
    },
    youTube: {
      set: function(editedData) {
        this.setSocialMediaValue(9)(editedData);
      },
      get: function() {
        return this.getSocialMediaValue(9);
      }
    }
  },
  methods: {
    ...mapMutations({
      deleteProperty: "deleteEditedProviderPropertyByKeyChain",
      setProperty: "setEditedProviderByKeyChain"
    }),
    getSocialMediaValue: function(i) {
      var value = this.getProperty([
        "provider_social_medias",
        {
          filterField: "social_media_id",
          filterValue: i
        },
        "url"
      ]);
      if (value) {
        return value;
      } else {
        return "";
      }
    },
    setSocialMediaValue: function(i) {
      var self = this;
      var f = function(editedData) {
        var value = self.getProperty([
          "provider_social_medias",
          {
            filterField: "social_media_id",
            filterValue: i
          }
        ]);
        if (value) {
          // edit
          var index = self
            .getProperty(["provider_social_medias"])
            .findIndex(socialMedia => {
              return socialMedia.social_media_id == value.social_media_id;
            });
          self.setProperty({
            data: editedData,
            keyChain: ["provider_social_medias", index, "url"]
          });
        } else {
          if (editedData != "") {
            // create
            var vals = self.getProperty(["provider_social_medias"]);
            var socialMedia = _createSocialMediaObj(i);
            socialMedia.url = editedData;
            vals.push(socialMedia);
            self.setProperty({
              data: vals,
              keyChain: ["provider_social_medias"]
            });
          }
        }
      };
      return f;
    }
  }
};

function _createSocialMediaObj(i) {
  return {
    social_media: {
      id: i
    },
    social_media_id: i,
    url: undefined
  };
}
</script>



// WEBPACK FOOTER //
// src/elements/socialMedia.vue